import React from 'react';
import useSearchQuery from '@magoosh/utils/use_search_query';

import Preview from './preview';
import Metric from './metric';

interface Props {}

const MetricPage: React.FC<Props> = (props) => {
  const preview = useSearchQuery()['preview'] === 'true';

  if (preview) {
    return <Preview />;
  } else {
    return <Metric />
  }
};

export default MetricPage;
